import React from 'react'

const NotAuthenticated = (props) => {
  return (
    <div>Not Authenticated</div>
  )
}

export default NotAuthenticated